<template lang="pug">
div.wrap-module-top
  div.top-content.pt20
    div.f.flex-between
      div(v-if="currentSubTabComics || currentSubTabAssets"
        ).wrap-sub-tab.f.overflow-hidden.rounded.mb20
        span(v-for="item in subTabContents"
          @click="onSubTab(currentTab, item)"
          :class="{'active': (currentSubTabComics && item.name == currentSubTabComics.name) || (currentSubTabAssets && currentSubTabAssets.name)}"
          ).py6.fz10.text-center.bold.cursor-pointer {{item.label}}    
    div(v-if="currentTab.name === 'comics'").wrap-result.f.flex-between.flex-wrap
      ItemComicCard(v-for="comic in comics" :comic="comic" :key="comic.id")
    div(v-if="currentTab.name === 'assets'").wrap-result.f.flex-between.flex-wrap
      ItemAssetCard(v-for="asset in assets" :asset="asset" :key="asset.id")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-top {
  padding-top: $header_height;
  .top-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    .wrap-sub-tab {
      span {
        width: 72px;
        color: $secondary_text_color;
        background: $tertiary_bg_color;
        &.active {
          color: $dark_primary_text_color;
          background: $active_color;
        }
      }
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ItemComicCard from '@/components/item/ItemComicCard'
import ItemAssetCard from '@/components/item/ItemAssetCard'

export default {
  components: {
    ItemComicCard,
    ItemAssetCard
  },
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // }
  },
  computed: {
    ...mapStateAuth(['uid']),
    subTabContents () {
      return this.currentTab.name === 'comics' ?
        [
          // { label: '人気', name: 'popular-comics' },
          { label: '注目', name: 'featured-comics' },
          { label: '最新', name: 'latest-comics' }
        ]
        : [
          { label: '人気', name: 'popular-assets' },
          // { label: '注目', name: 'featured-assets' },
          { label: '最新', name: 'latest-assets' }
        ]
    }
  },
  watch: {
    currentTab () {
      switch (this.currentTab.name) {
        case 'comics':
          if (this.currentSubTabComics === null) {
            this.currentSubTabComics = { label: '注目', name: 'featured-comics' }
          }
          break
        case 'assets':
          if (this.currentSubTabAssets === null) {
            this.currentSubTabAssets = { label: '人気', name: 'popular-assets' }
          }
          break
      }
    },
    currentSubTabComics () {
      this.comics = []
      this.oldestSecondsOfComic = new Date().getTime() / 1000
      this.loadMoreComics = true
      switch (this.currentSubTabComics.name) {
        case 'featured-comics':
          this.minimumComicPageViewSumNum = 100000000000000
          this.loadFeaturedComics()
          break
        case 'latest-comics':
          this.loadLatestComics()
          break
      }
    },
    currentSubTabAssets () {
      this.assets = []
      this.oldestDateOfAsset = new Date()
      this.loadMoreAssets = true
      switch (this.currentSubTabAssets.name) {
        case 'featured-assets':
          this.loadFeaturedAssets()
          break
        case 'latest-assets':
          this.loadLatestAssets()
          break
      }
    }
  },
  data () {
    return {
      tabContents: [
        { label: '漫画', name: 'comics' },
        { label: 'アセット', name: 'assets' },
      ],
      currentTab: { label: '漫画', name: 'comics' },
      currentSubTabComics: null,
      currentSubTabAssets: null,
      comics: [], assets: [],
      oldestSecondsOfComic: new Date().getTime() / 1000,
      oldestDateOfAsset: new Date(),
      minimumComicPageViewSumNum: 100000000000000,
      loadMoreComics: true, loadMoreAssets: true,
      loadLimit: 8,
      isLoading: false
    }
  },
  created () {
    if (this.$route.params.tab) {
      const tab = this.$route.params.tab
      const subTab = this.$route.params.subTab
      // 不明なパスはリダイレクト
      if (tab && (!subTab || !['comics', 'assets'].includes(tab))) {
        this.$router.replace('/')
        this.currentSubTabComics = { label: '注目', name: 'featured-comics' }
        return
      }
      if (subTab) {
        this.currentTab = this.tabContents.filter(t => t.name === tab)[0]
        if (tab === 'comics') {
          if (subTab === 'featured-comics') this.currentSubTabComics = { label: '注目', name: 'featured-comics' }
          if (subTab === 'latest-comics') this.currentSubTabComics = { label: '最新', name: 'latest-comics' }
        }
        if (tab === 'assets') {
          if (subTab === 'featured-assets') this.currentSubTabAssets = { label: '人気', name: 'popular-assets' }
          if (subTab === 'latest-assets') this.currentSubTabAssets = { label: '最新', name: 'latest-assets' }
        }
      } else {
        this.currentTab = this.tabContents.filter(t => t.name === tab)[0]
      }
    } else {
      this.currentSubTabComics = { label: '注目', name: 'featured-comics' }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onSubTab (tab, subTab) {
      if (tab.name === 'comics') this.currentSubTabComics = subTab
      if (tab.name === 'assets') this.currentSubTabAssets = subTab
      this.$router.replace(`/${tab.name}/${subTab.name}`)
    },
    onScroll () {
      const bottomPoint = document.body.clientHeight - window.innerHeight
      if (bottomPoint <= window.scrollY + 10) {
        if (!this.isLoading) {
          if (this.currentTab.name === 'comics') {
            switch (this.currentSubTabComics.name) {
              case 'featured-comics':
                if (this.loadMoreComics) this.loadFeaturedComics()
                break
              case 'latest-comics':
                if (this.loadMoreComics) this.loadLatestComics()
                break
            }
          }
          if (this.currentTab.name === 'assets') {
            switch (this.currentSubTabAssets.name) {
              case 'popular-assets':
                if (this.loadMoreAssets) this.loadPopularAssets()
                break
              case 'latest-assets':
                if (this.loadMoreAssets) this.loadLatestAssets()
                break
            }
          }          
        }
      }
    },
    async loadFeaturedComics () {
      if (!this.loadMoreComics) return
      this.isLoading = true
      
      let newComics = await database.comicCollection()
        .getFeaturedComics({
          pageViewSumNum: this.minimumComicPageViewSumNum,
          seconds: this.oldestSecondsOfComic,
          limit: this.loadLimit
        })
      if (!newComics[0]) {
        // 同じminimumComicPageViewSumNum帯にない場合はdateをリセットして一個したの帯を探してみる
        this.oldestSecondsOfComic = new Date().getTime() / 1000
        newComics = await database.comicCollection()
          .getFeaturedComics({
            pageViewSumNum: this.minimumComicPageViewSumNum - 1,
            seconds: this.oldestSecondsOfComic,
            limit: this.loadLimit
          })
        if (!newComics[0]) {
          this.isLoading = false
          this.loadMoreComics = false
          return
        }
      }
      this.comics = this.comics.concat(newComics)
      this.minimumComicPageViewSumNum = newComics[newComics.length - 1].pageViewSumNum
      this.oldestSecondsOfComic = newComics[newComics.length - 1].postedAt._seconds
      // if (newComics.length < this.loadLimit) this.loadMoreComics = false

      this.isLoading = false
    },
    async loadLatestComics () {
      if (!this.loadMoreComics) return
      this.isLoading = true
      
      const newComics = await database.comicCollection()
        .getLatestComics({
          seconds: this.oldestSecondsOfComic,
          limit: this.loadLimit
        })
      // console.log('newComics:', newComics)
      if (!newComics[0]) {
        this.isLoading = false
        this.loadMoreComics = false
        return
      }
      this.comics = this.comics.concat(newComics)
      this.minimumComicPageViewSumNum = newComics[newComics.length - 1].pageViewSumNum
      this.oldestSecondsOfComic = newComics[newComics.length - 1].postedAt._seconds
      // if (newComics.length < this.loadLimit) this.loadMoreComics = false

      this.isLoading = false
    },
    async loadPopularAssets () {

    },
    async loadLatestAssets () {

    }
  }
}
</script>
